import { useMemo } from "react";

type Props = {
	//
	free: string;
	// 名称
	name: string;
	// 料金
	price: number;
	// お支払い料金
	actualPrice: number;
};

export const PrintItemTBodyLayout = ({ free, name, price, actualPrice }: Props) => {
	const priceText = useMemo(() => `¥ ${price.toLocaleString()}`, [price]);
	const actualPriceText = useMemo(() => `¥ ${actualPrice.toLocaleString()}`, [actualPrice]);

	return (
		<div className="grid grid-cols-12">
			<div className="col-span-2 border border-zinc-200 p-1">
				<p>{free}</p>
			</div>
			<div className="col-span-6 border border-zinc-200 p-1">
				<p>{name}</p>
			</div>
			<div className="col-span-2 border border-zinc-200 p-1 text-right">
				<p>{priceText}</p>
			</div>
			<div className="col-span-2 border border-zinc-200 p-1 text-right">
				<p>{actualPriceText}</p>
			</div>
		</div>
	);
};
